<template>
  <AppDialog :is-open="isDialogOpened"
             size="l"
             @cancel="closeDialog"
  >
    <template #title>
      {{ archive.docName }}
    </template>

    <template #subTitle>
      {{ $t("archives.dialogs.ArchivesListDetailsDialog.subtitle") }}
    </template>

    <template #body>
      <v-data-table :headers="fields"
                    disable-sort
                    :items="[archive]"
                    class="archive-list-details-modal-table"
      >
        <template #item.signersNames="{ item }">
          <ArchivesListSignersNames :signers-names="item.signersNames.split(',')" />
        </template>
        <template #item.archiverName="{ item }">
          <ArchivesListArchiverName :name="item.archiverName" />
        </template>
        <template #item.signedDate="{ item }">
          <DateDisplay :value="item.signedDate" />
        </template>
        <template #item.docExt="{ item }">
          <ClosdFildersIcon :document="item" :signedFile="item.isSigned == true"/>
        </template>
        <template #item.docSize="{ item }">
          <app-filesize-display :value="item.docSize" />
        </template>
        <template #item.signedDocument="{ item }">
          <BooleanDisplay :value="item.isSigned == true" />
        </template>
        <template #item.archiveDate="{ item }">
          <DateDisplay :value="item.archiveDate" />
        </template>
        <template #item.archiveEndDate="{ item }">
          <DateDisplay :value="item.archiveEndDate" />
        </template>

        <template #bottom />
      </v-data-table>
    </template>

    <template #footer>
      <app-button
        type="outlined"
        variant="neutral"
        class="mr-auto"
        @click="closeDialog"
      >
        {{$t('common.close')}}
      </app-button>
      <app-button
        type="outlined"
        variant="neutral"
        @click="actionClick('download')"
      >
        <app-material-icon name="download" color="inherit" />
        {{ $t("archives.dialogs.ArchivesListDetailsDialog.btnDownload") }}
      </app-button>
      <app-button
        v-if="isArchivingAdmin"
        @click="actionClick('share')"
      >
        {{ $t("archives.dialogs.ArchivesListDetailsDialog.btnShare") }}
      </app-button>
    </template>
  </AppDialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import BooleanDisplay from '@/common/BooleanDisplay.vue'
import DateDisplay from '@/common/DateDisplay.vue'
import AppDialog from '@/common/dialogs/AppDialog.vue'
import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

import ArchivesListArchiverName from '../ArchivesListArchiverName.vue'
import ArchivesListSignersNames from '../ArchivesListSignersNames.vue'

const { mapGetters } = createNamespacedHelpers('user')

export default {
  name: 'ArchivesListDetailsDialog',
  components: {
    AppDialog,
    ArchivesListArchiverName,
    ArchivesListSignersNames,
    BooleanDisplay,
    ClosdFildersIcon,
    DateDisplay,
  },
  mixins: [dialogMixin],
  props: {
    archive: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(['isArchivingAdmin']),
  },
  methods: {
    actionClick (actionName) {
      this.$emit('action', actionName)
      this.closeDialog()
    },
  },
}
</script>

<style lang="scss" scoped>
.archive-list-details-modal-table :deep(table) {
  thead,
  tbody {
    width: 50%;
    float: left;
  }

  tr {
    width: 100%;
    display:flex;
    flex-direction: column;
    float: left;

    th,
    td {
      height: 44px !important;
      display: flex;
      align-items: center;
      border: none !important;

      &:not(:last-child) {
        border-bottom: 1px solid rgb(var(--v-theme-border-primary)) !important;
      }
    }

    th {
      color: rgb(var(--v-theme-text-primary));
    }

    td {
      color: rgb(var(--v-theme-text-secondary));
    }
  }
}
</style>
